import {fetchGdt, stat, initConfig} from './adv';
import {checkStorge, splitUrl} from './lib';
import {getGjMachineId, isGjEnv, download, isQQEnv, isWXEnv} from './gj-api';

class CoralAdv {
  constructor(opt = {
    debug: false,
    appId: 0,
    stamp: '',
    nonceStr: '',
    token: '',
    apiList: []
  }) {
    let qs = splitUrl();
    let coralJs = document.getElementById("coral_js");
    this.appId = coralJs.getAttribute("appid") || opt.appId;
    this.env = coralJs.getAttribute("env");
    this.account = opt.account || opt.account_id || qs.account || qs.account_id;
    this.imei = opt.imei || qs.imei || qs.device_id;
    this.guid = opt.guid || qs.guid;
    this._h5Conf = {};

    this.openid = opt.login_openid;
    this.loginAppid = opt.login_appid;

    this.custom_channel = opt.custom_channel;
    this.screen_width = opt.screen_width;
    this.screen_height = opt.screen_height;
    this.oaid = opt.oaid;
    this.tdid = opt.tdid;
    this.adv_width = opt.adv_width;
    this.adv_height = opt.adv_height;

    // 检查ua是否微信
    this.loginType = "";
    if (isQQEnv()) {
      this.loginType = "2";
    }
    if (isWXEnv()) {
      this.loginType = "1";
    }
  }

  // 必须要在这里回调
  async ready(cb, errCb) {
    console.log("ready");
    let _this = this;

    if (isGjEnv()) {
      this.guid = await getGjMachineId();
      this.account = this.guid + '-' + new Date().getTime();
    }
    if (cb || errCb) {
      if (document.readyState !== 'loading') {
        doInit(cb, errCb)
      } else if (window.addEventListener) {
        // DOMContentLoaded - 所有DOM解析完会触发整个事件 不需要等到样式表、图片等加载完。
        window.addEventListener('DOMContentLoaded', async () => {
          doInit(cb, errCb)
        });
      } else {
        window.attachEvent('onreadystatechange', async () => {
          if (document.readyState !== 'loading') ;
          doInit(cb, errCb)
        });
      }
    } else {
      return new Promise(async (resolve, reject) => {
        await doInit();
        resolve();
      })
    }

    async function doInit(cb, err) {
      try {
        await init(cb);

      } catch (e) {
        if (err) {
          err(e);
        }
      }
    }

    function init(cb) {
      // 做好检查和注册
      // 通过校验的话就要拉取给这个客户配置的广告资源
      console.log("init");
      return new Promise(async (resolve, reject) => {
        let {ret, data} = await initConfig(_this.appId);
        if (ret === 0) {
          _this._h5Conf = {
            coinName: data.coin_name,
            shortCoinName: data.short_coin_name,
            download_position_id: data.download_pos_id,
            video_position_id: data.video_pos_id,
            coupon_position_id: data.coupon_pos_id,
            banner_position_id: data.banner_pos_id,
          };
          _this.resource = data;
          console.log("珊瑚SDK初始化成功");
          if (cb) {
            cb();
          }
          resolve(data);
        } else {
          console.log("珊瑚SDK初始化错误", ret);
          reject({ret, data})
        }

        // 失败的话在这里回调
        if (!checkStorge) {
          reject("localstorage/sessionstorage disabled");
        }
      });
    }
  }

  get h5Conf() {
    return this._h5Conf;
  }

  /**
   * 获取一个视频广告
   * @param account
   * @param device
   * @returns {Promise<void>}
   */
  async getVideoAdv(account = this.account, device = this.imei) {
    const gdt = await fetchGdt(this.appId, account, this.resource.video_pos_id, device,
        this.guid, "video", this.resource.order_data,
        this.loginType, this.loginAppid, this.openid, this.custom_channel, this.screen_width,
        this.screen_height, this.oaid, this.tdid, this.adv_width, this.adv_height);
    let advList = gdt.vecAdvPositonResp[0].vecSecureAdvertise;
    let adv = {};

    if (advList.length) {
      console.log("原生数据", advList[0])
      let oTmpAdv = advList[0].advertise;
      let picWidth = oTmpAdv.displayInfo.picWidth;
      let picHeight = oTmpAdv.displayInfo.picHeight;
      if (picWidth > picHeight) { // 横屏
        adv.direct = 0;
      } else { // 竖屏
        adv.direct = 1;
      }
      adv.jumpUrl = oTmpAdv.content.jumpUrl;
      adv.isDownloadAdv = oTmpAdv.content.contentType === 2;
      if (adv.isDownloadAdv) {
        adv.downloadLink = oTmpAdv.content.appDownloadUrl;
        adv.pkgName = oTmpAdv.content.packageName;
        adv.advTitle = oTmpAdv.displayInfo.text2;
        adv.advIcon = oTmpAdv.displayInfo.imgUrl2;
        adv.advDesc = oTmpAdv.displayInfo.text1;
      }
      //视频下方广告页面
      let tmpUrl = adv.jumpUrl || oTmpAdv.content.customedUrl;
      if (tmpUrl && tmpUrl.indexOf("http") > -1) {
        adv.advUrl = tmpUrl.replace(/http\:/gi, 'https:');
      }

      // 如果找到广告
      adv.videoUrl = oTmpAdv.displayInfo.videoUrl.replace(/https/gi, 'http');

      adv.videoPoster = oTmpAdv.displayInfo.imgUrl1;
      adv.statCtx = oTmpAdv.context;
      // 拉取视频并且上报
      //account_id, positionId, phase, context, imei, guid
      stat(this.appId, account, this.resource.video_pos_id, 2, adv.statCtx, device, this.guid, "", this.resource.order_data);
    }
    return adv;
  }

  /**
   * 获取一个banner广告
   * @param account
   * @param device
   * @returns {Promise<void>}
   */
  async getBannerAdv(account = this.account, device = this.imei) {
    const gdt = await fetchGdt(this.appId, account, this.resource.banner_pos_id, device,
        this.guid, "banner", this.resource.order_data,
        this.loginType, this.loginAppid, this.openid, this.custom_channel, this.screen_width,
        this.screen_height, this.oaid, this.tdid, this.adv_width, this.adv_height);
    let advList = gdt.vecAdvPositonResp[0].vecSecureAdvertise;
    let adv = {};

    if (advList.length) {
      let oTmpAdv = advList[0].advertise;
      let picWidth = oTmpAdv.displayInfo.picWidth;
      let picHeight = oTmpAdv.displayInfo.picHeight;
      if (picWidth > picHeight) { // 横屏
        adv.direct = 0;
      } else { // 竖屏
        adv.direct = 1;
      }
      adv.desc = oTmpAdv.displayInfo.text1;
      adv.title = oTmpAdv.displayInfo.text2;
      adv.btnText = oTmpAdv.displayInfo.text3;
      adv.banner = oTmpAdv.displayInfo.imgUrl1;
      adv.icon = oTmpAdv.displayInfo.imgUrl2;
      adv.jumpUrl = oTmpAdv.content.jumpUrl;
      adv.isDownloadAdv = oTmpAdv.content.contentType === 2;

      //视频下方广告页面
      let tmpUrl = adv.jumpUrl || oTmpAdv.content.customedUrl;
      if (tmpUrl && tmpUrl.indexOf("http") > -1) {
        adv.advUrl = tmpUrl.replace(/http\:/gi, 'https:');
      }

      adv.statCtx = oTmpAdv.context;
      // 拉取视频并且上报
      //account_id, positionId, phase, context, imei, guid
      stat(this.appId, account, this.resource.banner_pos_id, 2, adv.statCtx,
          device, this.guid, "", this.resource.order_data);
    }
    return adv;
  }

  /**
   * 获取下载广告
   * @param account
   * @param device
   * @returns {Promise<void>}
   */
  async getDownloadAdv(account = this.account, device = this.imei) {
    const gdtSoftWare = await fetchGdt(this.appId, account, this.resource.download_pos_id,
        device, this.guid, "download", this.resource.order_data,
        this.loginType, this.loginAppid, this.openid, this.custom_channel, this.screen_width,
        this.screen_height, this.oaid, this.tdid, this.adv_width, this.adv_height);
    let adv = {};
    const swList = gdtSoftWare.vecAdvPositonResp[0].vecSecureAdvertise;
    if (swList.length) {
      let downloadContent = swList[0].advertise.content;
      let displayContent = swList[0].advertise.displayInfo;
      let context = swList[0].advertise.context;

      adv = {
        pkgName: downloadContent.packageName,
        advTitle: displayContent.text2,
        advIcon: displayContent.imgUrl2,
        downloadLink: downloadContent.appDownloadUrl,
        advDesc: displayContent.text1,
        statCtx: context
      };

      stat(this.appId, account, this.resource.download_pos_id, 2, context, device, this.guid, "", this.resource.order_data);
    }
    return adv;
  }

  /**
   * 获取卡券广告
   * @param account
   * @param device
   * @returns {Promise<void>}
   */
  async getCouponAdv(account = this.account, device = this.imei) {
    const gdtSoftWare = await fetchGdt(this.appId, account, this.resource.coupon_pos_id,
        device, this.guid, "coupon", this.resource.order_data,
        this.loginType, this.loginAppid, this.openid, this.custom_channel, this.screen_width,
        this.screen_height, this.oaid, this.tdid, this.adv_width, this.adv_height);
    let adv = {};
    const swList = gdtSoftWare.vecAdvPositonResp[0].vecSecureAdvertise;
    if (swList.length) {
      let content = swList[0].advertise.content;
      let displayContent = swList[0].advertise.displayInfo;
      let context = swList[0].advertise.context;

      adv = {
        img: displayContent.imgUrl2,
        title: displayContent.text1,
        appName: displayContent.text2,
        btnText: displayContent.test3,
        jumpUrl: content.jumpUrl,
        appDownloadUrl: content.appDownloadUrl,
        statCtx: context
      };

      stat(this.appId, account, this.resource.coupon_pos_id, 2, context, device, this.guid, "", this.resource.order_data);
    }
    return adv;
  }

  statVideo(phase, context) {
    stat(this.appId, this.account, this.resource.video_pos_id,
        phase, context, this.imei, this.guid, "", this.resource.order_data);
  }

  statDownload(phase, context) {
    stat(this.appId, this.account, this.resource.download_pos_id, phase,
        context, this.imei, this.guid, "", this.resource.order_data);
  }

  statCoupon(phase, context) {
    stat(this.appId, this.account, this.resource.coupon_pos_id,
        phase, context, this.imei, this.guid, "", this.resource.order_data);
  }

  statBanner(phase, context) {
    stat(this.appId, this.account, this.resource.banner_pos_id,
        phase, context, this.imei, this.guid, "", this.resource.order_data);
  }

  downloadApp(type, downloadUrl, pkgName, context) {
    const posId = type === 'video' ? this.resource.video_pos_id : this.resource.download_pos_id;
    stat(this.appId, this.account, posId, 4, context, this.imei, this.guid,
        "", this.resource.order_data);

    return download(posId, downloadUrl, pkgName, context);
  }
}

export default CoralAdv;
